export class ApiService {
    constructor() {
        this.baseUrl = process.env.REACT_APP_BASE_BE_URL;
    }

    buildHeaders(additionalHeaders = {}) {
        const headers = { ...additionalHeaders };
        const apiVersion = localStorage.getItem('api-version');
        if (apiVersion) {
            headers['x-api-version'] = apiVersion;
        }
        return headers;
    }

    async login({ userId, language, screenDimensions }) {
        let url = `${this.baseUrl}/api/login`;
        if (userId) {
            url += `/${userId}`;
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: this.buildHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({
                language,
                // screenDimensions,
                screen: {
                    w: window.innerWidth,
                    h: window.innerHeight,
                },
            }),
        });

        return response.json();
    }

    async getGame({ userId, gameId }) {
        const response = await fetch(
            `${this.baseUrl}/api/${userId}/game/${gameId}`,
            {
                method: 'POST',
                headers: this.buildHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );

        return response.json();
    }

    async startGame({ userId, storyId }) {
        const version = localStorage.getItem('prompt-version');
        const response = await fetch(
            `${this.baseUrl}/api/${userId}/game/start/${storyId}${
                version ? `?version=${version}` : ''
            }`,
            {
                method: 'POST',
                headers: this.buildHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );

        return response.json();
    }

    async startCustomGame({ userId, prompt }) {
        const version = localStorage.getItem('prompt-version');
        const response = await fetch(
            `${this.baseUrl}/api/${userId}/game/prompt/start${
                version ? `?version=${version}` : ''
            }`,
            {
                method: 'POST',
                body: JSON.stringify({ prompt }),
                headers: this.buildHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );

        return response.json();
    }

    async executeAction({ userId, gameId, actionId }) {
        const response = await fetch(
            `${this.baseUrl}/api/${userId}/game/${gameId}/action/${actionId}`,
            {
                method: 'POST',
                headers: this.buildHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );

        return response.json();
    }

    async executeCustomAction({ userId, gameId, prompt }) {
        const response = await fetch(
            `${this.baseUrl}/api/${userId}/game/${gameId}/prompt`,
            {
                method: 'POST',
                body: JSON.stringify({
                    prompt,
                }),
                headers: this.buildHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );

        return response.json();
    }

    async deleteGames({ userId }) {
        await fetch(`${this.baseUrl}/api/${userId}/game/all`, {
            method: 'DELETE',
            headers: this.buildHeaders({
                'Content-Type': 'application/json',
            }),
        });
    }

    async getGameHistory({ userId, gameId, cursor }) {
        const response = await fetch(
            `${this.baseUrl}/api/${userId}/game/${gameId}/history/${cursor}`,
            {
                method: 'POST',
                headers: this.buildHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );

        return response.json();
    }
}
